import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { getRequest } from "../api";

import Main from "../layouts/Main";

import { SingleItem, BlogSidebar } from "../components/Blog";
import { Subscribe } from "../components/HomePage";
import PageBanner from "../components/PageBanner";

class SingleBlog extends Component {
  state = {
    blogPosts: [],
    blogData: {},
    assets: []
  };

  getBlogDetails = async () => {
    const { id } = this.props.match.params;

    try {
      const res = await getRequest({
        url: `entries/${id}`,
        params: {
          access_token: "qvwzHgDak_-zkrmMQidw7IXtM4U4Xs-M9SdFJl6kJMM"
        }
      });

      this.setState({
        blogData: res.data.fields
      });
    } catch (error) {
      console.log(error);
    }
  };

  getBlogPosts = async () => {
    const { limit, skip } = this.state;

    try {
      const res = await getRequest({
        url: "entries",
        params: {
          access_token: "qvwzHgDak_-zkrmMQidw7IXtM4U4Xs-M9SdFJl6kJMM",
          limit,
          skip,
          content_type: "event"
        }
      });

      this.setState({
        blogPosts: res.data.items,
        assets: res.data.includes.Asset
      });
    } catch (error) {
      console.log(error);
    }
  };

  componentDidMount() {
    this.getBlogDetails();
    this.getBlogPosts();
  }

  render() {
    return (
      <Main>
        <PageBanner title="Resource Details" />
        <section className="ls s-pb-30 s-pt-60 s-pt-md-90 s-py-lg-90 s-py-xl-120">
          <div className="container">
            <div className="row c-gutter-60">
              <SingleItem {...this.state} />
              <BlogSidebar {...this.state} />
            </div>
          </div>
        </section>
      </Main>
    );
  }
}

export default withRouter(SingleBlog);
